import axios from 'axios';

const url = '/api/v1/external/stripe';

class LocalStripeService {
    
    
    static attachPaymentMethod(data, token) {
        
        return axios.post(url + "/payment-methods/attach", {
            data: data
        },
        {
            headers: {Authorization: `Bearer ${token}`}
        })
    }
    
    static createCustomer(customer, token) {
        
        return axios.post(url + "/create-customer", {
            data: customer
        },
        {
            headers: {Authorization: `Bearer ${token}`}
        })
    }

    static getAllProducts() {
        
        return axios.get(url + "/subscribe-customer", {
            data: subscription
        },
        {
            headers: {Authorization: `Bearer ${token}`}
        })
    }
    
    static getSubscription(subscriptionId, token) {
        return axios.get(url + "/subscription/" + subscriptionId, {
            headers: {Authorization: `Bearer ${token}`}
        })
    }

    static subscribeCustomer(subscription, token) {

        return axios.post(url + "/subscribe-customer", {
            data: subscription
        },
        {
            headers: {Authorization: `Bearer ${token}`}
        })

    }

    static unsubscribeCustomer(subscriptionId, token) {
        return axios.post(url + "/unsubscribe-customer", {
            data: {subscriptionId: subscriptionId}
        },
        {
            headers: {Authorization: `Bearer ${token}`}
        }) 
    }

    static updateSubsciption(subscriptionId, subscription, token) {
        return axios.put(url + "/update-subscription", {
            data: {
                subscriptionId: subscriptionId,
                subscription: subscription
            }
        },
        {
            headers: {Authorization: `Bearer ${token}`}
        }) 
    }
}

export default LocalStripeService; 